import { render } from "./AposTagApply.vue?vue&type=template&id=f767e75c&scoped=true"
import script from "./AposTagApply.vue?vue&type=script&setup=true&lang=js"
export * from "./AposTagApply.vue?vue&type=script&setup=true&lang=js"

import "./AposTagApply.vue?vue&type=style&index=0&id=f767e75c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f767e75c"],['__file',"ui/ui/apos/components/AposTagApply.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f767e75c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f767e75c', __exports__)) {
    api.reload('f767e75c', __exports__)
  }
  
  module.hot.accept("./AposTagApply.vue?vue&type=template&id=f767e75c&scoped=true", () => {
    api.rerender('f767e75c', render)
  })

}


export default __exports__